const genderList = [
  {
    value: 1,
    text: 'Male',
    text_en: 'Male',
    text_bn: 'পুরুষ'
  },
  {
    value: 2,
    text: 'Female',
    text_en: 'Female',
    text_bn: 'মহিলা'
  },
  {
    value: 3,
    text: 'Others',
    text_en: 'Others',
    text_bn: 'অন্যান্য'
  }
]
const markingTypeList = [
  { value: 1, text_en: 'Description', text_bn: 'বর্ণনা' },
  { value: 2, text_en: 'Percentage', text_bn: 'শতাংশ' },
  { value: 3, text_en: 'Mark', text_bn: 'মার্ক' }
]
const wardTypeList = [
  {
    id: 1,
    name: 'City Corporation',
    name_bn: 'সিটি কর্পোরেশন'
  },
  {
    id: 2,
    name: 'Pauroshoba',
    name_bn: 'পৌরসভা'
  },
  {
    id: 3,
    name: 'Union',
    name_bn: 'ইউনিয়ন'
  }
]
const donationTypeList = [
  {
    value: 1,
    text: 'Assistive Device',
    text_en: 'Assistive Device',
    text_bn: 'সহায়ক ডিভাইস'
  },
  {
    value: 2,
    text: 'Money',
    text_en: 'Money',
    text_bn: 'টাকা'
  },
  {
    value: 3,
    text: 'Medicine',
    text_en: 'Medicine',
    text_bn: 'ওষুধ'
  }
]
const areaTypeList = [
  {
      value: 1,
      text_en: 'City Corporation',
      text_bn: 'সিটি কর্পোরেশন'
  },
  {
      value: 2,
      text_en: 'Pauroshoba',
      text_bn: 'পৌরসভা'
  },
  {
      value: 3,
      text_en: 'Union',
      text_bn: 'ইউনিয়ন'
  }
]
const municipalityList = [
  {
      value: 1,
      text_en: 'Municipality One',
      text_bn: 'Municipality One'
  },
  {
      value: 2,
      text_en: 'Municipality Two',
      text_bn: 'Municipality Two'
  },
  {
      value: 3,
      text_en: 'Municipality Three',
      text_bn: 'Municipality Three'
  }
]
const maritalStatusList = [
  {
    value: 1,
    text: 'Married',
    text_en: 'Married',
    text_bn: 'বিবাহিত'
  },
  {
    value: 2,
    text: 'Single',
    text_en: 'Single',
    text_bn: 'অবিবাহিত'
  },
  {
    value: 3,
    text: 'Divorced',
    text_en: 'Divorced',
    text_bn: 'তালাকপ্রাপ্ত'
  }
]
const assitiveDeviceApplicationTypeList = [
  { value: 1, text_en: 'PWD/ Guardian', text_bn: 'প্রতিবন্ধী ব্যক্তি/ অভিভাবক' },
  { value: 2, text_en: 'Organization or NGO', text_bn: 'সংস্থা বা এনজিও' },
  { value: 3, text_en: 'Special Representative', text_bn: 'বিশেষ প্রতিনিধি' },
  { value: 4, text_en: 'PSOSK Demand', text_bn: 'পিএসওএসকের চাহিদা' }
]
const assitiveDeviceApplicationList = [
  { value: 1, text_en: 'PWD/ Guardian', text_bn: 'প্রতিবন্ধী ব্যক্তি/ অভিভাবক' },
  { value: 2, text_en: 'Organization or NGO', text_bn: 'সংস্থা বা এনজিও' },
  { value: 3, text_en: 'Special Representative', text_bn: 'বিশেষ প্রতিনিধি' }
]
const educationalBoardList = [
  {
      value: 1,
      text: 'Dhaka',
      text_en: 'Dhaka',
      text_bn: 'ঢাকা'
  },
  {
      value: 2,
      text: 'Rajshahi',
      text_en: 'Rajshahi',
      text_bn: 'রাজশাহী'
  },
  {
      value: 3,
      text: 'Cumilla',
      text_en: 'Cumilla',
      text_bn: 'কুমিল্লা'
  },
  {
      value: 4,
      text: 'Jashore',
      text_en: 'Jashore',
      text_bn: 'যশোর'
  },
  {
      value: 5,
      text: 'Chattogram',
      text_en: 'Chattogram',
      text_bn: 'চট্টগ্রাম'
  },
  {
      value: 6,
      text: 'Barishal',
      text_en: 'Barishal',
      text_bn: 'বরিশাল'
  },
  {
      value: 7,
      text: 'Sylhet',
      text_en: 'Sylhet',
      text_bn: 'সিলেট'
  },
  {
      value: 8,
      text: 'Madrasah',
      text_en: 'Madrasah',
      text_bn: 'মাদ্রাসা'
  },
  {
      value: 9,
      text: 'Technical',
      text_en: 'Technical',
      text_bn: 'কারিগরি'
  },
  {
      value: 10,
      text: 'Dinajpur',
      text_en: 'Dinajpur',
      text_bn: 'দিনাজপুর'
  },
  {
      value: 11,
      text: 'Mymensingh',
      text_en: 'Mymensingh',
      text_bn: 'ময়মনসিংহ'
  },
  {
      value: 12,
      text: 'BOU',
      text_en: 'BOU',
      text_bn: 'বিওইউ'
  }
]
const educationalResultTypeList = [
  {
      value: 0,
      text: 'Do not mention',
      text_en: 'Do not mention',
      text_bn: 'উল্লেখ করবেন না'
  },
  {
      value: 1,
      text: 'First Division/Class',
      text_en: 'First Division/Class',
      text_bn: 'প্রথম বিভাগ/শ্রেণী'
  },
  {
      value: 2,
      text: 'Second  Division/Class',
      text_en: 'Second  Division/Class',
      text_bn: 'দ্বিতীয় বিভাগ/শ্রেণী'
  },
  {
      value: 3,
      text: 'Third Division/Class',
      text_en: 'Third Division/Class',
      text_bn: 'তৃতীয় বিভাগ/শ্রেণী'
  },
  {
      value: 4,
      text: 'Grade',
      text_en: 'Grade',
      text_bn: 'গ্রেড'
  },
  {
      value: 5,
      text: 'Appeared',
      text_en: 'Appeared',
      text_bn: 'প্রকাশিত'
  },
  {
      value: 6,
      text: 'Enrolled',
      text_en: 'Enrolled',
      text_bn: 'নথিভুক্ত'
  },
  {
      value: 7,
      text: 'Awarded',
      text_en: 'Awarded',
      text_bn: 'ভূষিত'
  },
  {
      value: 8,
      text: 'Pass',
      text_en: 'Pass',
      text_bn: 'পাস'
  }
]
function generateYearList () {
  const min = new Date().getFullYear()
  const oldMax = min - 10
  const newMax = min + 5
  const newYears = []
  const oldYears = []
  for (let i = oldMax; i < min; i++) {
      oldYears.push(i)
  }
  for (let j = min; j <= newMax; j++) {
      newYears.push(j)
  }
  const yearList = [...oldYears, ...newYears]
  return yearList
}

const yearList = generateYearList()

export default {
  genderList,
  markingTypeList,
  wardTypeList,
  yearList,
  donationTypeList,
  municipalityList,
  areaTypeList,
  maritalStatusList,
  assitiveDeviceApplicationTypeList,
  assitiveDeviceApplicationList,
  educationalBoardList,
  educationalResultTypeList
}
